import { render, staticRenderFns } from "./InsuranceTable.vue?vue&type=template&id=09551bad&scoped=true"
import script from "./InsuranceTable.vue?vue&type=script&lang=js"
export * from "./InsuranceTable.vue?vue&type=script&lang=js"
import style0 from "./InsuranceTable.vue?vue&type=style&index=0&id=09551bad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09551bad",
  null
  
)

export default component.exports